import React from "react";
import Modal from "apollo-react/components/Modal";
import Typography from "apollo-react/components/Typography";

const ApprovalConfirmationModal = ({ isOpen, onClose, onConfirm, isProcessing }) => {
  const handleConfirm = () => {
    onConfirm();
  };

  const handleClose = () => {
    if (!isProcessing) {
      onClose();
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      title="Confirm Approval"
      size="medium"
      buttonProps={[
        {
          label: 'Cancel',
          onClick: handleClose,
          disabled: isProcessing
        },
        {
          label: 'Confirm',
          onClick: handleConfirm,
          disabled: isProcessing,
          variant: 'primary',
          status: 'success'
        }
      ]}
    >
      <div style={{ padding: "20px 0" }}>
        <Typography
          variant="bodyDefault"
          style={{ color: "#333", textAlign: "center" }}
        >
          Are you sure you want to approve this request?
        </Typography>
      </div>
    </Modal>
  );
};

export default ApprovalConfirmationModal; 